import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ComponentModule } from '@app/component/component.module';
import { SearchField } from '@core/base/objects/search/search-field';
import { SearchOperator } from '@core/base/objects/search/search-operator.enum';
import { Pagination } from '@core/objects/pagination';
import { SortOrder } from '@core/objects/sort-order';
import { SessionService } from '@core/services/session.service';
import { RestSearchUtil } from '@core/utils/rest-search-util';
import { User } from '@shared/user/user';
import { WorkflowTask } from '@shared/workflow/task/workflow-task';
import { WorkflowTaskApi } from '@shared/workflow/task/workflow-task-api.service';

@Component({
  selector: 'app-workflow-task-widget',
  templateUrl: './workflow-task-widget.component.html',
  styleUrls: ['./workflow-task-widget.component.scss'],
  imports: [ComponentModule],
})
export class WorkflowTaskWidgetComponent implements OnInit {
  @Input() daysUntilDeadline!: number;

  displayColumns = ['title', 'group', 'dueDate'];

  private currentUser!: User | null;
  tasks!: WorkflowTask[];

  constructor(
    private readonly sessionService: SessionService,
    private readonly workflowTaskApi: WorkflowTaskApi,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    // Keep watching the userSession for other user info
    this.sessionService.sessionInfo$.subscribe(sessionInfo => {
      this.currentUser = sessionInfo.user;
      this.refreshWorkflowTasks();
    });
  }

  private refreshWorkflowTasks(): void {
    this.daysUntilDeadline = this.daysUntilDeadline
      ? this.daysUntilDeadline
      : this.route.snapshot.data.daysUntilDeadline;

    const today = new Date();
    const searchDate = new Date();
    searchDate.setTime(today.getTime() + this.daysUntilDeadline * 24 * 60 * 60 * 1000);

    if (!this.currentUser?.uuid) {
      return;
    }

    const searchFields = [
      {
        fieldName: 'performer.uuid',
        operator: SearchOperator.EQ,
        value: this.currentUser.uuid,
      } as SearchField,
      {
        fieldName: 'dueDate',
        operator: SearchOperator.LE,
        value: searchDate.getTime(),
      } as SearchField,
      {
        fieldName: 'done',
        operator: SearchOperator.EQ,
        value: false,
      } as SearchField,
    ];

    const filter = RestSearchUtil.createSearchFieldGroup(searchFields);
    const pagination = new Pagination(0, 1000, new SortOrder('dueDate'));
    this.workflowTaskApi.findByRequest(filter, pagination).subscribe(result => {
      this.tasks = result.content;
    });
  }
}
